Vue.component('doughnut-chart', {
    props: ['chart-data', 'url', 'dates'],

    data () {
        return {
            chart: null
        };
    },

    mounted () {
        let data = {
            labels: [],
            data: [],
            colors: null
        };

        for (let key in this.chartData) {
            let label = key;

            if (label == '') {
                label = 'N/A';
            } else {
                label = key.split('_').join(' ').toUpperCase();
            }

            data.labels.push(label);
            data.data.push(this.chartData[key]);
        }

        data.colors = this.getRandomColor(data.labels.length);

        this.chart = new Chart($(this.$el).find('canvas'), {
            type: 'doughnut',
            data: {
                labels: data.labels,
                datasets: [{
                    data: data.data,
                    backgroundColor: data.colors,
                }],
                options: {
                    responsive: true
                }
            },
            options: {
                onClick: (event, array) => {
                    var active = this.chart.getElementAtEvent(event);
                    if (active === 'undefined' || active == null || active.length === 0) {
                        return;
                    }

                    var elementIndex = active[0]._datasetIndex;

                    if (array[elementIndex] === 'undefined' || array[elementIndex] == null){
                        return;
                    }

                    var chartData = array[elementIndex]['_chart'].config.data;
                    var idx = array[elementIndex]['_index'];

                    var label = chartData.labels[idx].toLowerCase();

                    if (label != 'n/a') {
                        window.location = this.url + label + '&date_from=' + this.dates.from + '&date_to=' + this.dates.to;
                    }
                }
            },
            responsive: true
        });
    },

    methods: {
        getRandomColor (int) {
            let colors = [];

            for (let go = 1; go <= int; go++) {
                let letters = '0123456789ABCDEF'.split('');
                let color = '#';

                for (let i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }

                colors.push(color);
            }

            return colors;
        }
    },

    template: `<div style="position: relative;"><canvas></canvas></div>`
});